export enum Languages {
  En = 'en-EN',
  De = 'de-DE'
}
